import { useMutation, useQueryClient } from '@tanstack/react-query';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../lib/firebase';

interface DeleteMLSParams {
  organizationId: string;
  boardCode: string;
}

/**
 * Custom hook to delete an MLS subscription from a tenant
 * @returns Mutation function and state for deleting an MLS subscription
 */
export const useDeleteMLS = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organizationId, boardCode }: DeleteMLSParams) => {
      if (!organizationId) throw new Error('Organization ID is required');
      if (!boardCode) throw new Error('Board code is required');

      // Delete the MLS subscription document from the subscribedMLS subcollection
      const mlsDocRef = doc(db, 'tenants', organizationId, 'subscribedMLS', boardCode);
      await deleteDoc(mlsDocRef);

      return { success: true, boardCode };
    },
    onSuccess: (_, { organizationId }) => {
      queryClient.invalidateQueries({ queryKey: ['tenant', organizationId] });
    },
  });
};
